module.exports = __webpack_public_path__ + "img/C1.dd929100.svg";